<section class="page-title-area" [class.compact]="hideButton">
    <div class="pageWrap">
        <div class="container">

            <div class="row align-items-center text-white mb-3">
                <div class="col-md-6 mb-4 mb-md-0">

                    <div class="text-center text-md-start">
                        <h1 [class.m-0]="hideButton">{{title}}</h1>
                        <div class="h5 lh-15 mb-3" *ngIf="!hideButton">{{subTitle}}</div>
                        <a *ngIf="!hideButton && !buttonLink.startsWith('http')"
                            [routerLink]="buttonLink ? (buttonLink | route) : null"
                            class="btn btn-light">{{buttonText}}</a>
                        <a *ngIf="!hideButton && buttonLink.startsWith('http')" [href]="buttonLink" target="_blank"
                            rel="noopener noreferrer" class="btn btn-light">{{buttonText}}</a>
                    </div>
                </div>

                <div class="col-md-6 text-center text-md-end" *ngIf="src2">
                    <div class="">
                        <img width="450" src="{{src2}}" alt="image" class="img-fluid" />
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>